import {
  AUTOMATION_PENDING_PAGE_SIZE,
  automationApi,
  type AutomationPending,
} from '@/api/automationApi';

export async function fetchAllPendingForRun(args: {
  profileId: string;
  ruleId: string;
  scheduledSlot?: string | null;
  status?: string;
}): Promise<AutomationPending[]> {
  const items: AutomationPending[] = [];
  let offset = 0;
  let total = 0;

  for (let pageIndex = 0; pageIndex < 20; pageIndex += 1) {
    const res = await automationApi.listPending(args.profileId, {
      rule_id: args.ruleId,
      status: args.status ?? 'pending',
      ...(args.scheduledSlot ? { scheduled_slot: args.scheduledSlot } : {}),
      limit: AUTOMATION_PENDING_PAGE_SIZE,
      offset,
    });
    if (!res.success) {
      throw new Error(res.message || 'Failed to load pending actions');
    }
    const pageItems = res.data?.items ?? [];
    total = res.data?.total ?? pageItems.length;
    items.push(...pageItems);
    if (pageItems.length === 0 || items.length >= total) {
      break;
    }
    offset += pageItems.length;
  }

  if (items.length < total) {
    throw new Error('Pending actions did not load completely');
  }
  return items;
}
